import { noop } from "./function"

export type DeferredPromise<T> = {
  promise: Promise<T>
  resolve: (arg: T) => void
  reject: (reason: unknown) => void
  isSettled: boolean
}

export const createDeferredPromise = <T>(): DeferredPromise<T> => {
  let isSettled = false
  let resolve: (arg: T) => void = noop
  let reject: (reason: unknown) => void = noop
  const promise = new Promise<T>((innerResolve, innerReject) => {
    resolve = (arg: T) => {
      innerResolve(arg)
      isSettled = true
    }
    reject = (reason: unknown) => {
      innerReject(reason)
      isSettled = true
    }
  })

  return {
    promise,
    resolve,
    reject,
    get isSettled() {
      return isSettled
    },
  }
}
